import FocusMixin from './focus'

export default {
  mixins: [FocusMixin],
  watch: {
    '$v.$error': function (newValue) {
      if (newValue) {
        this.$nextTick(this.startScrollIntoView)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validation-error-focus.js